'use strict';

function CompanyPublicationWatcherService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/publications/:publicationId/watchers/:watcherId', {});
}

angular.module('dokiv')
  .factory('CompanyPublicationWatcherService', ['$resource', 'config', CompanyPublicationWatcherService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/CompanyPublicationWatcherService.js
// module id = 62
// module chunks = 0